import { orderBy } from "lodash-es";

import i18n from "i18next";
import clsx from "clsx";
import { ECONTACT_TYPE } from "src/pages/Sources/SourceAddContactDetailsModal";

export const API_SERVER_IP = process.env.REACT_APP_API_SERVER_IP;
export const API_SERVER_PORT = process.env.REACT_APP_API_SERVER_PORT;
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY || "";

export const FILE_STORAGE_SERVER_URL =
  "https://expenser-bucket.s3.amazonaws.com";

export const API_SERVER_FULL_URL =
  `${API_SERVER_IP}` + (API_SERVER_PORT ? `:${API_SERVER_PORT}` : "");

export const PAYMENT_METHODS = () =>
  orderBy(
    [
      {
        name: i18n.t("payment_methods.card"),
        id: "CARD",
        settings: {
          bg: { r: 28, g: 216, b: 236, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.transfer"),
        id: "TRANSFER",
        settings: {
          bg: { r: 247, g: 90, b: 158, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.cash"),
        id: "CASH",
        settings: {
          bg: { r: 150, g: 209, b: 17, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.wallet"),
        id: "WALLET",
        settings: {
          bg: { r: 182, g: 135, b: 53, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.check"),
        id: "CHECK",
        settings: {
          bg: { r: 74, g: 37, b: 198, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.phone"),
        id: "PHONE",
        settings: {
          bg: { r: 184, g: 16, b: 134, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.digital"),
        id: "DIGITAL",
        settings: {
          bg: { r: 0, g: 0, b: 0, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.prepaid_card"),
        id: "PREPAID_CARD",
        settings: {
          bg: { r: 0, g: 0, b: 0, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
      {
        name: i18n.t("payment_methods.contactless"),
        id: "CONTACTLESS",
        settings: {
          bg: { r: 3, g: 99, b: 220, a: 1 },
          color: { r: 255, g: 255, b: 255, a: 1 },
        },
      },
    ],
    ["name"],
    ["asc"]
  );

export const TRANSACTION_STATUSES = () => [
  {
    id: "PENDING",
    name: i18n.t("transaction_status.pending"),
    className: clsx(["bg-red-500", "text-red-50"]),
    settings: {
      color: {
        r: 250,
        g: 15,
        b: 54,
        a: 1,
      },
      bg: {
        r: 250,
        g: 15,
        b: 54,
        a: 1,
      },
    },
  },
  {
    id: "NULL",
    name: i18n.t("transaction_status.null"),
    className: clsx(["bg-gray-100", "text-gray-500"]),
    settings: {
      color: {
        r: 250,
        g: 15,
        b: 54,
        a: 1,
      },
      bg: {
        r: 75,
        g: 85,
        b: 99,
        a: 1,
      },
    },
  },
  {
    id: "PAID",
    name: i18n.t("transaction_status.paid"),
    className: clsx(["bg-green-500", "text-green-50"]),
    settings: {
      color: {
        r: 74,
        g: 222,
        b: 128,
        a: 1,
      },
      bg: {
        r: 41,
        g: 224,
        b: 15,
        a: 1,
      },
    },
  },
];

export const CHART_COLORS = {
  TOOLTIP: {
    bg: { r: 0, g: 0, b: 0, a: 0.8 },
  },
  EXPENSE: {
    color: {
      r: 255,
      g: 255,
      b: 255,
      a: 1,
    },
    bg: {
      r: 250,
      g: 15,
      b: 54,
      a: 1,
    },
  },
  INCOME: {
    color: {
      r: 255,
      g: 255,
      b: 255,
      a: 1,
    },
    bg: {
      r: 41,
      g: 224,
      b: 15,
      a: 1,
    },
  },
  BALANCE: {
    color: {
      r: 192,
      g: 192,
      b: 192,
      a: 1,
    },
    bg: {
      r: 0,
      g: 0,
      b: 0,
      a: 1,
    },
  },
  TICKS: {
    dark: {
      color: "#ccc",
    },
    light: {
      color: "#777",
    },
  },
  GRID: {
    dark: {
      color: "#444",
    },
    light: {
      color: "#f0f0f0",
    },
  },
};

export const APP_TOKEN_KEY = "token";
export const APP_USER_ID_KEY = "user";
export const APP_LOCAL_STORAGE_ACCOUNTS = "accounts";
export const APP_LOCAL_STORAGE_USER_DATA = "user-data";

// notes endpoints
export const API_ENDPOINT_ALL_NOTES = "/tasks";
export const API_ENDPOINT_ADD_NOTE = "/task";
export const API_ENDPOINT_UPDATE_NOTE = "/task";
export const API_ENDPOINT_DELETE_TASK = "/task";

// links endpoints
export const API_ENDPOINT_ALL_LINKS = "/links";
export const API_ENDPOINT_ADD_LINK = "/link";
export const API_ENDPOINT_DELETE_LINK = "/link";

// transactions endpoints
export const API_ENDPOINT_ALL_INVOICES = "/invoices";
export const API_ENDPOINT_ADD_INVOICE = "/invoice";
export const API_ENDPOINT_UPDATE_INVOICE = "/invoice";
export const API_ENDPOINT_UPDATE_TRANSACTION = "/transaction-text-update";

export const API_ENDPOINT_DELETE_INVOICE = "/invoice";
export const API_ENDPOINT_GET_INVOICE = "/invoice";
export const API_ENDPOINT_CLONE_TRANSACTION = "/clone/transaction";

// auth endpoints
export const API_ENDPOINT_LOGIN = "/login";
export const API_ENDPOINT_REGISTER = "/register";

// profile
export const API_ENDPOINT_UPDATE_PROFILE = "/user";

// account endpoints
export const API_ENDPOINT_ALL_ACCOUNTS = "/accounts";
export const API_ENDPOINT_ADD_ACCOUNT = "/account";
export const API_ENDPOINT_UPDATE_ACCOUNT = "/account";
export const API_ENDPOINT_DELETE_ACCOUNT = "/account";
export const API_ENDPOINT_GET_ACCOUNT = "/account";
export const API_ENDPOINT_UPLOAD_ATTACHMENT = "/upload";

// categories endpoints
export const API_ENDPOINT_ALL_CATEGORIES = "/categories";
export const API_ENDPOINT_ADD_CATEGORY = "/category";
export const API_ENDPOINT_GET_CATEGORY = "/category";

export const API_ENDPOINT_ALL_SOURCES = "/sources";
export const API_ENDPOINT_ADD_SOURCE = "/source";

export const API_ENDPOINT_SEARCH_NETWORK = "/search-network";
export const API_ENDPOINT_SEND_INVITE = "/invite";
export const API_ENDPOINT_GET_INVITES = "/invites";

export const API_ENDPOINT_PARSE_XML = "/parser/xml";

export const PLANS = {
  FREE: {
    name: "Gratuito",
    permissions: [],
  },
  HOME: {
    name: "Hogar",
    permissions: [],
  },
  SMALLBUSINESS: {
    name: "Empresa",
    permissions: [],
  },
};

export const FILE_TYPE_PDF = "PDF";
export const FILE_TYPE_XML = "XML";
export const FILE_TYPE_IMG = "IMG";

export const LOAD_TYPE = "LOAN";

export enum ETransactionType {
  INCOME = "INCOME",
  EXPENSE = "EXPENSE",
  LOAN = "LOAN",
  TRANSFER = "TRANSFER",
}

export enum EIncomeType {
  CASH = "CASH",
  CREDIT = "CREDIT",
}

export enum EExpenseType {
  CASH = "CASH",
  CREDIT = "CREDIT",
}

export enum ELoanType {
  PAYABLE = "PAYABLE",
  RECEIVABLE = "RECEIVABLE",
}

interface ITransactionSubType {
  ID: string;
  NAME: string;
}

interface ITransactionCategory<T extends string> {
  ID: T;
  NAME: string;
  TYPES: Record<string, ITransactionSubType>;
}

interface ITransactionWithoutCategory<T extends string> {
  ID: T;
  NAME: string;
  TYPES: boolean;
}

export type ETransactionTypes = {
  [ETransactionType.INCOME]: ITransactionCategory<ETransactionType.INCOME>;
  [ETransactionType.EXPENSE]: ITransactionCategory<ETransactionType.EXPENSE>;
  [ETransactionType.LOAN]: ITransactionCategory<ETransactionType.LOAN>;
  [ETransactionType.TRANSFER]: ITransactionWithoutCategory<ETransactionType.TRANSFER>;
};

export const TRANSACTION_TYPES: ETransactionTypes = {
  [ETransactionType.INCOME]: {
    ID: ETransactionType.INCOME,
    NAME: "Ingreso",
    TYPES: {
      [EIncomeType.CASH]: {
        ID: EIncomeType.CASH,
        NAME: "Contado",
      },
      [EIncomeType.CREDIT]: {
        ID: EIncomeType.CREDIT,
        NAME: "Crédito",
      },
    },
  },
  [ETransactionType.EXPENSE]: {
    ID: ETransactionType.EXPENSE,
    NAME: "Gasto",
    TYPES: {
      [EExpenseType.CASH]: {
        ID: EExpenseType.CASH,
        NAME: "Contado",
      },
      [EExpenseType.CREDIT]: {
        ID: EExpenseType.CREDIT,
        NAME: "Crédito",
      },
    },
  },
  [ETransactionType.LOAN]: {
    ID: ETransactionType.LOAN,
    NAME: "Préstamo",
    TYPES: {
      [ELoanType.PAYABLE]: {
        ID: ELoanType.PAYABLE,
        NAME: "Contado",
      },
      [ELoanType.RECEIVABLE]: {
        ID: ELoanType.RECEIVABLE,
        NAME: "Crédito",
      },
    },
  },
  [ETransactionType.TRANSFER]: {
    ID: ETransactionType.TRANSFER,
    NAME: "Transferencia",
    TYPES: false,
  },
};

export const PAGINATION_ROWS_PER_PAGE_OPTIONS = [
  10, 25, 50, 100, 150, 200, 250,
];
export const [PAGINATION_MIN] = PAGINATION_ROWS_PER_PAGE_OPTIONS;

export const CHART_TRANSPARENCY_BG_COLOR = 1;

export const LATEST_TRANSACTIONS_COUNT = 10;

export const MOBILE_BREAKPOINT = 767;
export const TABLET_BREAKPOINT = 1023;
export const DESKTOP_BREAKPOINT = 1279;

export const BUTTON_STYLES = {
  HEADING: clsx(["!border-transparent", "!bg-transparent", "dark:!text-white"]),
};

export const TRANSACTIONS_EXPORT_FORMATS = [
  {
    id: "xlsx",
    name: "XLSX",
    description: "XLSX (Excel Spreadsheet)",
  },
  {
    id: "json",
    name: "JSON",
    description: "JSON (JavaScript Object Notation)",
  },
  { id: "csv", name: "CSV", description: "CSV (Comma-separated Values)" },
  { id: "pdf", name: "PDF", description: "PDF (Portable document format)" },
];

export const [
  TRANSACIONS_EXPORT_EXCEL_FORMAT,
  TRANSACIONS_EXPORT_JSON_FORMAT,
  TRANSACIONS_EXPORT_CSV_FORMAT,
  TRANSACIONS_EXPORT_PDF_FORMAT,
] = TRANSACTIONS_EXPORT_FORMATS;

export const INVOICE_NOTES = [
  `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla felis dui,`,
  `luctus ultrices ante quis, dignissim sodales tellus.Donec porttitor`,
  `dolor non nibh interdum venenatis.`,
].join("\n");

export const INVITE_STATUS_SENT = "SENT";
export const API_ENDPOINT_DELETE_INVITE = "/invite";
export const API_ENDPOINT_ACCEPT_INVITE = "/accept-invite";

export const API_ENDPOINT_GET_USERS = "/users";

export const CATEGORIES_DEFAULT_TEXT_COLOR = { r: 255, g: 255, b: 255, a: 1 };
export const CATEGORIES_DEFAULT_BG_COLOR = { r: 0, g: 0, b: 0, a: 1 };
export const CATEGORIES_DEFAULT_ICON = "MdCategory";

export const SOURCES_DEFAULT_TEXT_COLOR = { r: 255, g: 255, b: 255, a: 1 };
export const SOURCES_DEFAULT_BG_COLOR = { r: 0, g: 0, b: 0, a: 1 };
export const SOURCES_DEFAULT_ICON = "MdQuestionMark";

export const TOAST_TEXT_COLOR = { r: 255, g: 255, b: 255, a: 1 };
export const TOAST_BG_COLOR = { r: 0, g: 0, b: 0, a: 0.8 };

export const MOBILE_BREAKPOINT_MEDIA_QUERY = "(max-width: 767px)";

export const ICON_SIZES = {
  XS: 16,
  SM: 24,
  MD: 32,
  MD_LG: 32 + 8,
  LG: 48,
  XL: 64,
};

export const CACHE_KEYS = {
  FILTERED_TRANSACTIONS: "transactions",
  ALL_TRANSACTIONS: "all-transactions",
  ALL_CURRENT_ACCOUNT_TRANSACTIONS: "all-current-account-transactions",
  ALL_CATEGORIES: "all-categories",
  CURRENT_USER_ACCOUNTS: "user-accounts",
  CURRENT_USER: "current-user",
  ALL_INVITES: "all-invites",
  ALL_USERS: "all-users",
  CURRENT_USER_NOTES: "user-notes",
  ALL_SOURCES: "all-sources",
};

export const REPORTS_TABS = {
  TRANSACTIONS_BY_TYPE_CHART: 0,
  TRANSACTIONS_BY_CATEGORY_CHART: 1,
  TRANSACTIONS_BY_PAYMENT_METHOD_CHART: 2,
  TRANSACTIONS_PER_MONTH_CHART: 3,
  TRANSACTIONS_PER_CLIENT_PROVIDER_CHART: 4,
  TRANSACTIONS_LAST_SEVEN_DAYS: 5,
  TRANSACTIONS_BY_STATUS: 6,
};

export const TRANSACTIONS_TABS = {
  ACTIVE_TRANSACTIONS: 0,
  ARCHIVED_TRANSACTIONS: 1,
  TRANSACTIONS_ATTACHMENTS: 2,
  RECYCLED_TRANSACTIONS: 3,
};

export const NOTIFICATIONS_TABS = {
  RECURRING_TRANSACTIONS: 0,
  PENDING_TRANSACTIONS: 1,
  MY_NETWORK: 2,
  SHARED_TRANSACTIONS: 3,
};

export const TABLE_SELECTION_DEFAULTS = {
  allSelected: false,
  selectedCount: 0,
  selectedRows: [],
};

export const PAGINATION_PAGE_SIZES = [5, 10, 15, 20, 25, 30];

export const CONTACT_DEFAULT_ICONS = {
  [ECONTACT_TYPE.EMAIL]: "MdOutlineEmail",
  [ECONTACT_TYPE.PHONE]: "MdOutlinePhone",
  [ECONTACT_TYPE.LINK]: "MdOutlineLink",
  [ECONTACT_TYPE.SMS]: "MdOutlineChat",
};

export const ACCEPTED_ATTACHMENT_TYPES = [
  ".jpg",
  ".jpeg",
  ".png",
  "image/jpeg",
  "image/png",
  "application/pdf",
].join(",");

export const COUNT_UP_ANIMATION_DURATION = 0.5;
